import React from 'react';
import { MyTeamNameComponent } from 'react/match/active/MyTeamNameComponent.jsx';
import { OtherTeamNameComponent } from 'react/match/active/OtherTeamNameComponent.jsx';
import { UserComponent } from "../../UserComponent";

class TeamComponent extends React.PureComponent {
	static defaultProps = {
		displayPlayers: false,
	};

	render() {
		const { team, match, displayPlayers } = this.props;
		if(displayPlayers) {
			return (
				<React.Fragment>
					{team.players.map((player) => {
						return (
							<UserComponent
								key={player.id}
								user={player}
								showModGavel={false}
							/>
						);
					})}
				</React.Fragment>
			);
		}

		if(match.getMyTeamNumber() === team.number) {
			return <MyTeamNameComponent match={match} />;
		}
		else {
			return <OtherTeamNameComponent match={match} />;
		}
	}
}

export { TeamComponent };